export default __webpack_public_path__ + "static/media/usdc.85b6b40d.svg";